import * as React from "react";
import { FC } from "react";
import { Feature } from "ol";
import { Collapsible } from "./Collapsible";
import { DemoMiniMaps } from "./DemoMiniMap";

export interface IDemoRoutes {
    routeList: Feature[];
    onSelectRoute: (routeId: string) => void;
    onToggleRouteMiniMap: (routeId: string, isOn: boolean) => void;
}

export const DemoRoutes: FC<IDemoRoutes> = (props: IDemoRoutes) => {
    let routeId: string;
    return (
        <Collapsible title="Maršruti" defaultCollapsed={true}>
            <div className="list route">
                <input
                    type="text"
                    title="atlasīt maršrutu pēc id"
                    placeholder="atlasīt maršrutu pēc id"
                    onChange={(e) => (routeId = e.target.value)}
                />
                <button title={"select-route"} onClick={() => props.onSelectRoute(routeId)}>
                    Atlasīt maršrutu
                </button>
            </div>
            <DemoMiniMaps onToggleRouteMiniMap={props.onToggleRouteMiniMap} routeList={props.routeList}></DemoMiniMaps>
        </Collapsible>
    );
};
